module.exports = __webpack_public_path__ + "static/media/Email Notification Test_1633785300542.3fa2c751.vtt";